import { BankAccountApi } from "@/api/BankAccountApi";
import { CreditOperatorApi } from "@/api/CreditOperatorApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CARD_PAYMENT_WAY_CODE, CHEQUE_PAYMENT_WAY_CODE, DIGITAL_PLATFORM_PAYMENT_WAY_CODE, SINPE_PAYMENT_WAY_CODE, TAXES_TYPES, TRANSFER_PAYMENT_WAY_CODE } from "@utils/Constants";
import { generatePaymentWayOptions } from "@utils/EDocument";

const CancelInvoiceFormConfig = {
    submit: {
        label: "Crear Pago"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "hidden",
                        "name": "currencyId",
                    },
                    {
                        "type": "hidden",
                        "name": "exchange_rate",
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "fecha",
                        "label": "Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "monto",
                        "isDecimal": true,
                        "step": "0.01",
                        "isHorizontal": true,
                        "min": "1",
                        "label": "Monto",
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "formaPago",
                        "label": "Forma de Pago",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "options": generatePaymentWayOptions(),
                        "validation": Yup.string().required("Este campo es requerido"),
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "digitosTarjeta",
                        "label": "Ultimos 4 digitos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "visibleIf": {
                            "formaPago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "creditOperatorId",
                        "label": "Operador de Tarjeta",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "optionsFunction": () => CreditOperatorApi.optionsList(),
                        "visibleIf": {
                            "formaPago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "numAprobacion",
                        "label": "Numero Aprobacion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "visibleIf": {
                            "formaPago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "reference",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "visibleIf": {
                            "formaPago": [
                                `${CHEQUE_PAYMENT_WAY_CODE}`,
                                `${TRANSFER_PAYMENT_WAY_CODE}`,
                                `${SINPE_PAYMENT_WAY_CODE}`,
                                `${DIGITAL_PLATFORM_PAYMENT_WAY_CODE}`,
                            ]
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "bankAccountId",
                        "label": "Cuenta Bancaria",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "visibleIf": {
                            "formaPago": [
                                `${CHEQUE_PAYMENT_WAY_CODE}`,
                                `${TRANSFER_PAYMENT_WAY_CODE}`,
                                `${SINPE_PAYMENT_WAY_CODE}`,
                                `${DIGITAL_PLATFORM_PAYMENT_WAY_CODE}`,
                            ]
                        },
                        "optionsFunction": () => BankAccountApi.optionsList(),
                    }
                ],
            ]
        }
    ],
};


export default CancelInvoiceFormConfig;